<template>
  <main class="marketing-automation">
    <marketing-automation-list />
  </main>
</template>

<script>
import MarketingAutomationList from "@components/modules/marketing/automation/list/MarketingAutomationList";

export default {
  components: {
    MarketingAutomationList,
  },

  props: {},
};
</script>

<style lang="scss" scoped>
</style>
